export default "__VITE_ASSET__02a9e3b2__"